import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {ensureNotObject} from "../common";

// This is just a common renderer for adding/setting
// account overrides and manual values, as they have same API input.
export function AddOrSetRenderHelper(props: RendererProps): ReactElement {
    const values = props.variables["values"];
    const monthIndexes = props.variables["monthIndexes"];

    if(!Array.isArray(values) || values.length === 0 || !Array.isArray(monthIndexes) || monthIndexes.length === 0) {
        return <div>No change</div>;
    }

    const valueList: ReactElement[] = [];
    const min = Math.min(values.length, monthIndexes.length);
    for(let i = 0; i < min; i++) {
        const month = monthIndexes[i];
        const value = values[i];

        if(typeof month !== "number") {
            continue;
        }

        valueList.push(
                <li key={month}>Month {month}: {ensureNotObject(value)}</li>
        );
    }

    if(valueList.length === 0) {
        return <></>;
    }

    return <ul>
        {valueList}
    </ul>;
}